import { useContext } from 'react';
import { useQuery } from 'react-query';
import { AuthContext } from 'context/authContext';
import makeApiRequest from 'services/makeApiRequest';
import apiEndPoints from 'services/apiEndPoints';

export default function useLeaveReportAccess() {
  const { authState } = useContext(AuthContext);
  return useQuery(
    ['leave-report-access', authState?.user_id, authState?.token],
    async () => (await makeApiRequest.get(apiEndPoints.LEAVE_REPORT_OPTIONS)).data,
    { enabled: !!authState?.isAuthenticated, retry: false, staleTime: 60000 }
  );
}
